import { Box, Typography } from '@mui/material';
import { SessionDecisionTreeRunFieldsFragment, useGetDecisionTreeRunResultQuery } from '../../../../../../../../../../../../generated/core-api/graphql-react-query';
import useDecisionTreeReport from '../../../../../../../../../../DecisionTreeWindow/Pages/DecisionTreePage/DecisionTreeResult/Components/DecisionTreeResultSummary/Hooks/useDecisionTreeReport';
import useDecisionTreeReportQueries from '../../../../../../../../../../DecisionTreeWindow/Pages/DecisionTreePage/DecisionTreeResult/Components/DecisionTreeResultSummary/Hooks/useDecisionTreeReportQueries';
import useEnableSummary from '../../../../../../../../../../DecisionTreeWindow/Pages/DecisionTreePage/DecisionTreeResult/Components/DecisionTreeResultSummary/Hooks/useEnableSummary';
import NoSummary from '../../../../../../../../../../DecisionTreeWindow/Pages/DecisionTreePage/DecisionTreeResult/Components/DecisionTreeResultSummary/NoSummary';
import RunResultTag from '../RunResultTag';
import RunSequenceItem from './RunSequenceItem';

interface RunItemProps {
  run: SessionDecisionTreeRunFieldsFragment;
}

export default function RunItem(props: RunItemProps) {
  const { run } = props;
  const resultData = useGetDecisionTreeRunResultQuery({ input: { id: run.id ?? '' } }, { enabled: !!run.id });
  const result = resultData.data?.getDecisionTreeRun;
  const queries = useDecisionTreeReportQueries(run.id, result);
  const {
    generateReport, loading,
  } = useDecisionTreeReport(queries.data ?? []);
  const enableSummary = useEnableSummary();

  if (!result) {
    return null;
  }
  return (
    <Box>
      <Box className="header">
        <Typography variant="subtitle2">{result.decisionTree.name}</Typography>
        <RunResultTag finished={!!result.finishedAt} />
      </Box>
      {(result.decisionTree.llmQuestion && !!enableSummary) && (
        <Box className="content">
          {result.finishedAt && !result.summary ? (
            <NoSummary
              generateReport={generateReport}
              loading={loading}
            />
          ) : (
            <>
              <Typography variant="body2">
                {result.summary}
              </Typography>
              {result.sequence?.map((step) => (
                <RunSequenceItem step={step.run} key={step.runId} />
              ))}
            </>
          )}
        </Box>
      )}
    </Box>
  );
}
